<template>
  <div>
    <div class="relative mb-5">
      <div>
        <img src="../../assets/mobile/you.png" class="max-full-width" />
      </div>
      <div class="absolute you__username">
        <div class="you__username__name">
          <span> Salva </span>
          <img
            src="../../assets/mobile/icon/check-circle.svg"
            class="max-full-width"
          />
        </div>
        <div class="you__username__type">ACCOUNT</div>
      </div>
    </div>

    <div
      class="you__menu display-flex justify-space-between align-center my-3"
      v-for="(item, index) in itemList"
      :key="index"
      @click="() => item.handle()"
    >
      <div class="relative you__menu__icon">
        <div
          v-if="item.number > 0"
          class="absolute you__menu__icon--number display-flex justify-center align-center text-dmsans-12"
        >
          {{ item.number }}
        </div>
        <img :src="item.icon" />
      </div>
      <div class="you__menu--title">{{ item.text }}</div>
      <div class="w-22"></div>
    </div>

    <div class="mb-5"></div>

    <Footer />
  </div>
</template>

<script>
import Footer from "./components/footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      itemList: [
        {
          icon: require("@/assets/mobile/icon/library.svg"),
          text: "Library",
          number: 0,
          handle: () => this.$router.push({ name: "LibraryMobile" }),
        },
        {
          icon: require("@/assets/mobile/icon/cart.svg"),
          text: "Cart",
          number: 3,
          handle: () => this.$router.push({ name: "CartMobile" }),
        },
        {
          icon: require("@/assets/mobile/icon/trophy.svg"),
          text: "My Top Creators",
          number: 0,
        },
        {
          icon: require("@/assets/mobile/icon/setting.svg"),
          text: "Settings",
          number: 0,
        },
        {
          icon: require("@/assets/mobile/icon/youtube.svg"),
          text: "Learn",
          number: 0,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.you {
  &__username {
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    bottom: -24px;
    left: 22px;
    &__name {
      color: #fff;
      font-size: 24px;
      letter-spacing: -0.48px;
    }
    &__type {
      color: rgba(255, 255, 255, 0.9);
      font-size: 14px;
      letter-spacing: -0.28px;
    }
  }
  &__menu {
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.05);
    height: 50px;
    padding: 0px 17px;
    &--title {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }
    &__icon {
      max-width: 22px;
      height: 22px;
      &--number {
        border-radius: 100px;
        background: #ff4646;
        width: 16px;
        height: 16px;
        top: -8px;
        right: -8px;
      }
    }
  }
}

.w-22px {
  width: 22px;
}
/deep/.footer {
  background: #000 !important;
}
</style>



// WEBPACK FOOTER //
// you.vue?2b07fc74